/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsChannelTobResponseDto>
>;
export function request(
  params: API.tms.logisticsChannelTob.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelTob/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
